import { assertNotNull } from 'src/utils/assertion';
import { RootState } from 'src/react/root/state/RootState';

export const getOrganizationList = (state: RootState) => assertNotNull(
    state.organizationList.organizations,
    'Organization list state has to be fetched first',
    { state },
);
